<template>
  <loadable-content>
    <section v-if="has_header" class="page-content__header">
      <div class="page-content__header__title">
        <h1 v-if="$slots.header || $route.meta.title">
          <slot name="header"> {{ i18n_title }} </slot>
        </h1>
        <div v-if="$slots['top-buttons']" class="page-content__buttons">
          <slot name="top-buttons"></slot>
        </div>
        <div v-if="$slots['top-filter']" class="page-content__filter">
          <slot name="top-filter"></slot>
        </div>
      </div>
      <slot name="breadcrumb">
        <breadcrumbs
          :forced_dashboard="has_forced_dashboard"
          :forced_breadcrumbs="forced_breadcrumbs"
        />
      </slot>
    </section>
    <slot></slot>
  </loadable-content>
</template>

<script>
  import breadcrumbs from '@shared/components/layout-default/layout-default-breadcrumbs';
  export default {
    components: { breadcrumbs },
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    data: () => ({
      forced_breadcrumbs: [
        { title: 'core.breadcrumb.dashboard', route: 'dashboard' },
        { title: 'integrations.breadcrumb.title' }
      ]
    }),
    computed: {
      has_forced_dashboard: function () {
        return this.$route?.meta?.title?.code === 'integrations.breadcrumb.title';
      },
      has_header: function () {
        return this.$slots.breadcrumbs || this.$slots.header || this.$route.meta.title;
      },

      i18n_title: function () {
        return this.parse_i18n(this.$route.meta.title);
      },

      item_name: function () {
        return 'Name';
      }
    },

    methods: {
      parse_i18n: function (val) {
        try {
          if (val.title) {
            return val.title;
          } else if (val.code) {
            return this.$t(val.code);
          }

          return val;
        } catch (e) {
          return val;
        }
      }
    }
  };
</script>